import apiFetch from '../../apiFetch'

export default function (token, dossierId) {
  return apiFetch({ endPoint: `dossier/registrationDelivery/${dossierId}/header`, method: 'GET', body: null, token: token })
}
